import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

//STYLES
import * as SectionsStyles from "../../mainStyle/components/homeSections/styles/sections";

//COMPONENTS
import PageViewer from "../../../administration/pods/pageViewer/pageViewer";

function PageView(props) {
    const params = useParams();
    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);
    const navBarSettings = useSelector((state) => state.navBar);

    useEffect(() => {
        if (props.scroll) {
            document.body.style.overflow = "scroll";
        } else {
            document.body.style.overflow = "hidden";
        }
        console.log(`${params.pageNav}Image`);
        console.log(navBarSettings.backgroundImages[`${params.pageNav}Image`]);
    });
    return (
        <div
            style={{
                ...SectionsStyles.backgroundPicture,
                backgroundImage: `url('/content/mainStyle/sectionsBackgrounds/${navBarSettings.backgroundImages[`${params.pageNav}Image`]}')`
            }}
        >
            <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_blueBackground : SectionsStyles.blueBackground}>
                <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_insideContainer : SectionsStyles.insideContainer}>
                    <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_whiteCentredSection : SectionsStyles.whileCentredSection}>
                        <div style={SectionsStyles.contentContianer}>
                            <PageViewer pageID={params.pageID} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PageView;

{
    /* <div style={EditorialViewStyles.white}>
                Lorem ipsum odor amet, consectetuer adipiscing elit. Nisi sollicitudin viverra adipiscing; cras mi nunc. Porta consectetur
                sollicitudin in elit nostra sem facilisi. Venenatis tortor vestibulum facilisis id odio vivamus parturient. Purus class leo aptent
                habitasse tristique, curabitur malesuada. Egestas himenaeos diam ex scelerisque consequat efficitur. Ex phasellus ipsum iaculis
                maximus vulputate. Facilisis orci consequat magna adipiscing sollicitudin etiam nascetur mi. Rutrum at fermentum lacinia pellentesque
                vivamus mollis ante quam nibh. Adipiscing nisi phasellus ante tristique vehicula aliquet ridiculus senectus. Finibus nam placerat
                convallis interdum sapien. Eros dignissim pharetra tristique ultrices ultricies mattis sociosqu lectus. Egestas orci tristique tellus
                diam ornare porta laoreet lobortis. Sem ullamcorper senectus montes euismod semper lobortis fusce. Sodales gravida purus ultricies
                enim eros sollicitudin consectetur primis per. Libero tincidunt feugiat suscipit id inceptos consectetur curabitur nisl amet. Vel
                imperdiet varius conubia; porta tortor natoque nunc. Consectetur risus sodales vulputate aptent nostra ut dui venenatis. Consectetur
                tempus bibendum erat rhoncus metus sollicitudin; vestibulum sollicitudin. Tincidunt laoreet scelerisque duis ante conubia ut feugiat
                placerat diam. Fermentum felis pretium parturient molestie blandit. Aliquet sagittis massa efficitur lectus semper tempus vulputate
                aenean faucibus. Aliquam non penatibus per donec magna aliquam viverra pulvinar leo. Sem elit felis turpis venenatis ut litora non?
                Pretium integer non amet proin curae ridiculus cras. In felis mus lacinia sociosqu, odio nulla condimentum. Habitasse nostra laoreet
                tristique; ultricies diam lobortis inceptos ipsum. Ligula magna porttitor facilisis feugiat velit et penatibus cursus rutrum. Nullam
                pulvinar in nibh pellentesque class felis maximus netus. Ultricies eu mus euismod tellus imperdiet porta consequat. Adignissim curae
                hac nec varius turpis eu pellentesque luctus. Massa mollis tristique lacinia ultrices auctor; taciti dapibus est. Justo consectetur
                convallis mi tempor porttitor nec. Vehicula phasellus ad tincidunt cubilia magnis ac. Venenatis consequat ultricies justo lacus
                pretium. Ultricies elementum sed varius dictum pulvinar id adipiscing. Platea platea potenti dictum dis bibendum lorem suscipit eu
                scelerisque. Praesent condimentum accumsan posuere commodo; bibendum integer porttitor. Lorem ipsum senectus maecenas fringilla mus
                tempor mollis arcu efficitur. Purus risus class parturient turpis netus blandit fringilla ante suspendisse. Lectus posuere sagittis
                nunc ligula ac egestas! Montes pretium pharetra, arcu duis nisl suscipit. Viverra aliquet sollicitudin parturient vehicula turpis.
                Phasellus purus in in porta ac blandit odio convallis etiam. Pulvinar viverra nostra commodo sodales conubia molestie. Placerat mauris
                ultricies eu dictum maecenas odio vestibulum. Ridiculus sed ligula condimentum; venenatis suspendisse egestas dis. Suspendisse lacinia
                dictumst platea curabitur egestas proin id. Tellus finibus sem arcu dictum a vel. Quis aptent ante neque hac montes volutpat? Felis
                parturient mus neque habitant netus torquent, pretium fusce ipsum. Finibus libero laoreet in sociosqu dis cubilia duis. Cubilia dictum
                etiam ultrices efficitur nam sit. Potenti malesuada conubia magnis venenatis luctus sodales. Lectus lobortis ad dui conubia justo
                natoque pellentesque. Tempus integer consequat non sociosqu lectus nullam. Ornare dictumst maecenas arcu ultrices praesent rutrum.
                Pulvinar facilisi aliquam curae diam mi leo magna. Eu lectus ipsum montes massa quisque ligula integer. Potenti ultrices primis
                blandit per non praesent metus. Suscipit enim phasellus lobortis at augue lectus torquent placerat. Accumsan sagittis placerat eget
                volutpat dignissim aliquet nibh. Habitasse dis faucibus sapien vivamus suspendisse aliquam condimentum. Purus elementum eros odio
                egestas; hac lacinia aliquam consectetur? Sollicitudin convallis porta suscipit ridiculus lobortis lacinia per facilisis nibh.
                Habitant suscipit himenaeos hac molestie rutrum. Vulputate eros mi ipsum varius fusce eros fringilla. Massa et tempus et quisque
                finibus. Risus purus amet commodo mauris sed quam ullamcorper. Interdum fames dui justo dui dignissim litora tortor.
            </div> */
}
